(function () {
    'use strict';
    $(document).ready(function () {

        if (window.matchMedia("(min-width: 768px)").matches) {
            var blobSize = 300;
            var blobDetail = 60;
        } else {
            var blobSize = 200;
            var blobDetail = 45;
        }

        var blob = new BlobAnimation("blob-bg", {

            //Blob main settings
            BLOB_SIZE: blobSize,
            BLOB_DISTANCE: 1000,
            DETALISATION: blobDetail,
            PERSPECTIVE_DISTORTION: 1,
            ROTATION_SPEED: 2,

            //Dot settins
            DOT_SIZE: 2,
            DOT_COLOR: "#ACB2FC",

            //Mouse settings
            MOUSE_DISTANCE_MIN: 20,
            MOUSE_DISTANCE_MAX: 400,
            MOUSE_SENSITIVITY: .1,
            INERTIAL_TIME: 2,

            //Shape settins
            //Shape main settings
            INITIAL_SHAPE: {
                wave1: {amplitude: 10, frequency: 3, phase: 2},
                wave2: {amplitude: 60, frequency: 2, phase: 2},
                wave3: {amplitude: 10, frequency: 3, phase: 2}
            },
            USE_MORPHING: true,
            USE_WAVE_MOTION: true,
            USE_WAVE_SWING: false,

            //Morphing settings
            MORPHING_AUTOPLAY: true,
            MORPHING_DURATION: 20,
            MORPHING_DELAY: 2,
            MORPHING_TRANSITION_TYPE: "cubic",
            MORPHING_SHAPES: [
                {
                    wave1: {amplitude: 17.582, frequency: 3.736, phase: 0},
                    wave2: {amplitude: 32.967, frequency: 3.846, phase: 0},
                    wave3: {amplitude: 128.571, frequency: 1.044, phase: 0}
                },
                {
                    wave1: {amplitude: 59.341, frequency: 4.78, phase: 0},
                    wave2: {amplitude: 27.473, frequency: 4.286, phase: 0},
                    wave3: {amplitude: 12.088, frequency: 1.319, phase: 0}
                },
                {
                    wave1: {amplitude: 106.593, frequency: 1.319, phase: 0},
                    wave2: {amplitude: 114.286, frequency: 0.989, phase: 0},
                    wave3: {amplitude: 0, frequency: 2, phase: 0}
                },
                {
                    wave1: {amplitude: 54.945, frequency: 4.286, phase: 4.246},
                    wave2: {amplitude: 163.736, frequency: 0, phase: 5.213},
                    wave3: {amplitude: 0, frequency: 0, phase: 0}
                },
                {
                    wave1: {amplitude: 93.407, frequency: 2.582, phase: 0},
                    wave2: {amplitude: 29.67, frequency: 0.824, phase: 0},
                    wave3: {amplitude: 27.473, frequency: 1.319, phase: 0}
                },
                {
                    wave1: {amplitude: 95.604, frequency: 0.769, phase: 0},
                    wave2: {amplitude: 200, frequency: 0.989, phase: 0},
                    wave3: {amplitude: 163.736, frequency: 0, phase: 0}
                },
                {
                    wave1: {amplitude: 31.868, frequency: 2.857, phase: 0},
                    wave2: {amplitude: 29.67, frequency: 3.571, phase: 0},
                    wave3: {amplitude: 35.165, frequency: 3.242, phase: 0}
                },
                {
                    wave1: {amplitude: 32.967, frequency: 6.978, phase: 0.552},
                    wave2: {amplitude: 18.681, frequency: 10, phase: 0},
                    wave3: {amplitude: 17.582, frequency: 1.319, phase: 0.725}
                }
            ],

            //Wave motion settings
            WAVE_1_MOTION_SPEED: .3,
            WAVE_2_MOTION_SPEED: .3,
            WAVE_3_MOTION_SPEED: .3

        });

        gsap.to(".homepage #blob-bg", {
            scrollTrigger: {
                trigger: ".section-solutions",
                scrub: true,
            },
            opacity: 0
        });

        if (window.matchMedia("(min-width: 768px)").matches) {
            ScrollTrigger.create({
                trigger: ".solutions-list",
                pin: ".section-solutions h2",
                start: "top 180px",
                end: "bottom " + ($('.section-solutions h2').height() + 180) + "px",
            });
        }

        // gsap.utils.toArray('.solutions-list li').forEach(function(el) {
        //     gsap.to(el, {
        //         scrollTrigger: {
        //             trigger: el,
        //             start: "top 180px",
        //             end: "bottom 180px",
        //             toggleClass: "active"
        //         },
        //     });
        // });

        gsap.utils.toArray('.product-excerpt.even').forEach(function(el) {
            var tl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: "bottom bottom"
                }
            });
            tl.from(el.querySelector(".window"), {x: -500, opacity: 0, duration: 1});
            tl.to(el.querySelector(".window-bg"), {opacity: 1, duration: 1}, "-=1");
        });

        gsap.utils.toArray('.product-excerpt.odd').forEach(function(el) {
            var tl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: "top bottom + 500px"
                }
            });
            tl.from(el.querySelector(".window"), {x: 500, opacity: 0, duration: 1});
            tl.to(el.querySelector(".window-bg"), {opacity: 1, duration: 1}, "-=1");
        });

        function setSolutionWidth() {
            if ($('body').hasClass('home')) {
                if (window.matchMedia("(min-width: 768px)").matches) {
                    var docWidth = $(document).width();
                    var solContWidth = $('.section-solutions .container-fluid').width();
                    var solListContWidth = $('.section-solutions .col-md-7').width();
                    var totalSolWidth = solListContWidth + ((docWidth - solContWidth) / 2);
                    $('.solutions-list').css('width', totalSolWidth);
                } else {
                    $('.solutions-list').css('width', 'auto');
                }
            }
        }

        setSolutionWidth();
        $(window).on('resize', function() {
            setSolutionWidth();
        });

        var swiperPartners = new Swiper('.swiper-partners', {
            slidesPerView: 5,
            loop: true,
            freeMode: true,
            speed: 7500,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },

            breakpoints: {
                1199: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 3,
                },
                576: {
                    slidesPerView: 2,
                },
                375: {
                    slidesPerView: 1,
                },
            }
        });

    });
}(jQuery));
